import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Industrie = () => {
  const sectorData = {
    title: "Industrie",
    subtitle: "Accélérez votre prospection B2B",
    intro: "L'industrie 4.0 combine production, automatisation et digitalisation. Les fabricants et sous-traitants doivent prospecter avec des contenus éducatifs, de l'ingénierie commerciale et des références terrain. Mettre en avant la fiabilité, la durée de vie des équipements et le support SAV est stratégique.",
    name: "Industrie",
    titleContext: "dans l'industrie",
    responseContext: "du secteur de l'industrie",
    expertContext: "de l'industrie"
  };

  return <SectorPage sector={sectorData} />;
};

export default Industrie; 